<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     btn_copy
                     @copy="handleCopy"

        >
            <div class="pull-right">
                <el-button type="text" icon="el-icon-coffee-cup" @click="batch=true">同步用户信息</el-button>
            </div>
        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel">
            <div class="pull-left" slot="footer" v-if="$organization.use_contact">
                <el-button type="info" @click="loginWithTMUser">以用户身份登录腾讯</el-button>
            </div>
        </edit-dialog>

        <div class="clearfix"></div>
        <!--批量界面-->
        <el-dialog :visible.sync="batch" title="同步用户信息">
            <div class="text-info">点击同步，开始同步腾讯网上信息</div>
            <pusher-information-box :events="events" progress></pusher-information-box>
            <div slot="footer" class="">
                <el-button :loading="process.loading" size="medium" @click="syncTMUsers">同步用户</el-button>
                <el-button type="primary" @click="batch=false" size="medium">返回</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
import EditDialog from "../components/edit-dialog";
import FrontTable from "../components/front-table";
import FrontMixins from "../common/mixins/front-mixins";
import PusherInformationBox from "../components/pusher-information-box.vue";
import SseMixin  from "@/common/mixins/sse-mixin";

export default {
    mixins: [FrontMixins, SseMixin],
    name: 'admin-tm-user',
    components: {PusherInformationBox: PusherInformationBox, FrontTable, EditDialog},
    data() {
        return {
            batch: false,
            payload: {id: '1', max: 2},
            rooms: {},
            schedules: [],
        }
    },
    created() {
        this.model = 'Admin.TMUser';
    },
    methods: {
        syncTMUsers() {
            this.connectSSE(this.model + '.publish', null, this.reload);
        },
        loginWithTMUser() {
            this.$affirm('以' + this.single.username + '身份启动腾讯会议吗?').then(() => {
                this.$api("User.Transfer", {id:this.single.id}, 1).then(res => {
                    const url = res.data.data;
                    window.open(url, '_blank');
                });
            });
        }
    }
}

</script>

<style lang="scss">

</style>
